import { Component, OnInit } from '@angular/core';
import { InternalUser } from '@app/shared-module/models/admin/internal-user';
import { AdminService } from '@app/services/admin.service';
import { GlobalResponse, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-add-internal-user',
  templateUrl: './add-internal-user.component.html',
  styleUrls: ['./add-internal-user.component.scss']
})
export class AddInternalUserComponent implements OnInit {
  public headerTitle: string;
  public createFlag = false;
  public updateNameFlag = false;
  public updateRoleFlag = false;
  userID: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  userData: User;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    public dialogRef: MatDialogRef<AddInternalUserComponent>,
    private admServc: AdminService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.userData) {
      this.userID = this.userData._id ? this.userData._id : undefined;
      this.name = this.userData.name ? this.userData.name : '';
      this.email = this.userData.email_id ? this.userData.email_id : '';
      this.phone = this.userData.phone_no ? this.userData.phone_no : '';
      this.role = this.userData.role ? this.userData.role : '';
    } else if (this.role && this.role.length > 0) {
      // console.log(this.role);
    } else {
      this.role = 'Admin';
    }
  }
  createUser() {
    const user: any = {
      name: this.name,
      emailId: this.email,
      mobileNumber: this.phone,
      role: this.role
    };
    this.blockUI.start();
    this.admServc.addInternalUser(user).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.dialogRef.close(res.result);
      }
    }
    );
  }

  updateName() {
    if (this.name && this.name.length > 0) {
      const newName = this.name;
      this.blockUI.start();
      this.admServc.updateInternalUserDetails(this.userID, newName).subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.dialogRef.close(res.result);
        }
      });
    } else {
      this.toastr.error('Please enter name');
    }
  }

  updateRole() {
    // if (this.st && this.name.length > 0) {
    const newName = this.name;
    this.blockUI.start();
    this.admServc.uploadInternalUserRole(this.userID, this.role).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.dialogRef.close(res.result);
      }
    });
    // } else {
    //   this.toastr.error('Please enter name');
    // }
  }
}
